/* eslint-disable */
import api from '@/utils/api.js'

// 投诉骑手(三方运送)
// token                string    true    "认证token"
// vendorOrderID        string    true    "订单号"
// vendorID             int       true    "订单所属厂商ID"
// waybillVendorID      int       true    "运单所属厂商ID"
// complaintID          int       true    "投诉原因ID"
// waybillID		       	string	  false	  "运单ID"
export const APIComplaintRider = async (string) => {
  try {
    await api('v2/order/ComplaintRider', {
      method: 'POST',
      data: string
    })
  } catch (e) {
    console.error('order/ComplaintRider', e)
    throw e
  }
}

// 查询门店订单扣款记录
/* 
storeIDs	门店ID列表
vendorOrderID	订单ID
vendorIDs	订单所属厂商ID列表
fromTime	开始日期（包含），格式（2006-01-02 00:00:00），如果订单号为空此项必须要求
toTime	结束日期（包含），格式（2006-01-02 23:00:00），如果订单号为空此项必须要求
status	账单状态，0是未结账，1是已结账
type	扣款类型，1为差评补贴，2为优惠券
offset	结果起始序号（以0开始，缺省为0）
pageSize	结果页大小（缺省为50，-1表示全部 
*/
export const APIGetOrdersSupplement = async (query, noLoading = false) => {
  try {
    let res = await api('v2/order/GetOrdersSupplement', {
      method: 'GET',
      params: query,
      noLoading
    })
    return res
  } catch (e) {
    console.error('APIGetOrdersSupplement', e)
    throw e
  }
}

// 新增/修改扣款记录
// payload
/* 
新增
storeID              int        
vendorOrderID     string     
vendorID           string    
type                   int //扣款类型，1为差评订单补贴，2为优惠券
linkID                 int //作为冲账标志关联某条扣款记录，若新增为某一记录的冲账，则此字段填那条记录的id
supplementFee int        //扣款金额
comment           string         //备注

----
修改
id			    int
createdAt            time 	
storeID                int        
vendorOrderID    string     
vendorID             string    
status                  int        //账单状态，若已结账则不允许再修改 ，暂时 0为未结账，1为已结账,-1为作废
linkID                   int        //作为冲账标志关联某条扣款记录
type                     int        //扣款类型，1为差评订单补贴，2为优惠券
supplementFee   int        //扣款金额
billID                   string     //账单ID，后期可能关联账单用
comment            string     //备注
*/
export const APIAddUpdateOrdersSupplement = async (json, noLoading = false) => {
  try {
    let res = await api('v2/order/AddUpdateOrdersSupplement', {
      method: 'POST',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error('AddUpdateOrdersSupplement', e)
    throw e
  }
}

// 得到订单详情
// vendorOrderID
// vendorID
// refresh
export const APIGetOrderInfo = async (query, noLoading = true) => {
  try {
    let res = await api('v2/order/GetOrderInfo', {
      params: query,
      noLoading
    })
    return res
  } catch (e) {
    console.error('APIGetOrderInfo', e)
    throw e
  }
}

// 查询订单状态
export const orderStatusList = async (query, noLoading = true) => {
  try {
    const res = await api('v2/order/GetOrderStatusList', {
      params: query,
      noLoading
    })
    return res
  } catch (e) {
    throw e
  }
}

export const APIGetMatterOrderStatus = async (json) => {
  try {
    const res = api('v2/jxorder/GetMatterOrderStatus?vendorOrderID=' + json.vendorOrderID, {
      noLoading: true
    })
    return res
  } catch (e) {
    throw e
  }
}

// 重发京东物流
export const APISendFailedMatterOrder = async (json, noLoading = true) => {
  try {
    let res = await api('v2/jxorder/SendFailedMatterOrder', {
      method: 'POST',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error('SendFailedMatterOrder', e)
    throw e
  }
}




// WEBPACK FOOTER //
// ./src/apis/APIOrder.js